import { API } from "./api";

export const getAllVehicles = () => API.get(`/vehicles`);
export const getVehiclesWithType = (location, startDate, numberOfWeeks) =>
  API.post(`/vehicles/type`, { location, startDate, numberOfWeeks });

export const getVehicleswithoutscreen = (params = {}) => {
  return API.get(`/vehicles`, { params });
};

export const getVehiclesByOwner = (ownerId) =>
  API.get(`/vehicles/owner/${ownerId}`);
export const addVehicle = (vehicle) => API.post(`/vehicles`, vehicle);

export const deleteVehicle = (vehicleId) =>
  API.delete(`/vehicles/${vehicleId}`);

export const updateVehicle = (id, vehicles) =>
  API.put(`vehicles/${id}`, vehicles);

export const getOwners = () => API.get(`/owners`);
